module.exports = __webpack_public_path__ + "img/Dantam Hair 10B.e877e617.jpg";